import { AutoComplete } from 'antd';
import styled, { createGlobalStyle } from 'styled-components';
import { COLORS } from '@/theme';

export const StyledAutoComplete = styled(AutoComplete)``;

export const StyleGlobalStyles = createGlobalStyle`
  .auto-complete-popup {
    padding: 0.5rem;
    border: 1px solid ${COLORS.GREY};
    border-radius: 0.25rem;

    .ant-select-item-option-active {
      background-color: ${COLORS.BLACK};
    }
  }
`;
